<div class="row gap-sm">
  <ion-icon class="announcement-logo" name="chatbox-outline"></ion-icon>
  <span class="text-md grey-color-700 semi-bold">{{ 'announcements.title' | translate }}</span>
</div>

<div *ngIf="currentAnnouncement; else noCurrentActiveAnnouncement" class="announcement">
  <span class="text-sm semi-bold grey-color-700">{{ 'announcements.current' | translate }}</span>

  <span class="text-sm  grey-color-700">{{ getAnnouncementBodyByLanguage() }}</span>

  <div class="row gap-xs grey-color-500 vertical-center">
    <ion-icon name="pricetag-outline"></ion-icon>
    <span class="text-xs">{{ 'announcements.createModal.type' | translate }}: {{ 'announcements.typeOptions.' + currentAnnouncement.type | translate }}</span>
  </div>

  <div class="row gap-xs grey-color-500 vertical-center">
    <ion-icon name="business-outline"></ion-icon>
    <span class="text-xs">{{ 'global.verticals' | translate }}: {{ currentAnnouncement.customers.toString() }}</span>
  </div>

  <div *ngIf="currentAnnouncement.startDate" class="row gap-xs grey-color-500 vertical-center">
    <ion-icon name="today-outline"></ion-icon>
    <span class="text-xs">{{
      'announcements.startDate'
        | translate
          : { date: getDayMonthYear(currentAnnouncement.startDate), time: getHourMinute(currentAnnouncement.startDate) }
    }}</span>
  </div>

  <div *ngIf="currentAnnouncement.endDate" class="row gap-xs grey-color-500 vertical-center">
    <ion-icon name="today-outline"></ion-icon>
    <span class="text-xs">{{
      'announcements.endDate'
        | translate
          : { date: getDayMonthYear(currentAnnouncement.endDate), time: getHourMinute(currentAnnouncement.endDate) }
    }}</span>
  </div>

  <div class="row gap-md">
    <div class="announcement--btn text-btn--danger" (click)="openDisableAnnouncementModal()">
      <ion-icon name="close-outline"></ion-icon>
      <span class="text-md">{{ 'announcements.btnActions.delete' | translate }}</span>
    </div>

    <div
      class="announcement--btn grey-color-500"
      (click)="openCreateModifyAnnouncementModal(announcementModalActionsEnum.MODIFY)"
    >
      <ion-icon name="pencil-outline"></ion-icon>
      <span class="text-md">{{ 'announcements.btnActions.edit' | translate }}</span>
    </div>
  </div>
</div>

<ng-template #noCurrentActiveAnnouncement>
  <button
    class="btn btn--primary btn--sm announcement--btn__create"
    mat-raised-button
    (click)="openCreateModifyAnnouncementModal(announcementModalActionsEnum.CREATE)"
  >
    <ion-icon name="add"></ion-icon>
    <span class="text-md medium">{{ 'announcements.btnActions.create' | translate }}</span>
  </button>
</ng-template>
